<template>
  <ModalLayout icon="upload-slim" title="Upload files" @close="close">
    <UploadFiles class="mt-1" :validate="false" @done="uploadDone" :options="{
      url: '/api/social-products/social-boost/screenshots/' + meta.asset.id,
      accept: ['image/jpeg', 'image/png', 'image/gif', 'video/mp4', 'video/avi', 'video/mov']
    }" />
  </ModalLayout>
</template>
<script>
import ModalLayout from '../ModalLayout.vue'
import UploadFiles from '../../parts/UploadFiles.vue'

export default {
  name: 'UploadCreatives',
  components: { ModalLayout, UploadFiles },
  props: {
    meta: {
      type: null,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    close() {
      this.$Modal.instance.isOpen = false
    },
    uploadDone() {
      if (this.meta.onUploaded) {
        this.meta.onUploaded();
      }
      this.close();
    },
  },
}
</script>
